// External packages
import * as React from 'react';

export function useBulkSelection<T extends { id: string }>(
  items: T[] | undefined
) {
  const [selectedIds, setSelectedIds] = React.useState<string[]>([]);

  const allSelected = React.useMemo(
    () => items && items.length > 0 && selectedIds.length === items.length,
    [items, selectedIds]
  );
  const someSelected = selectedIds.length > 0 && !allSelected;

  const handleSelect = React.useCallback((id: string, checked: boolean) => {
    setSelectedIds((prev) =>
      checked ? [...prev, id] : prev.filter((selectedId) => selectedId !== id)
    );
  }, []);

  const handleSelectAll = React.useCallback(
    (checked: boolean) => {
      if (checked && items) {
        setSelectedIds(items.map((item) => item.id));
      } else {
        setSelectedIds([]);
      }
    },
    [items]
  );

  const clearSelection = React.useCallback(() => setSelectedIds([]), []);

  return {
    selectedIds,
    setSelectedIds,
    allSelected,
    someSelected,
    handleSelect,
    handleSelectAll,
    clearSelection,
  };
}
